import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { MediaApiService } from '@simOn/common/media';
import { Attachment } from '@simOn/common/models';
import { UAnimatedIcon, animatedIconUrl } from '@simOn/ui/sim-animated-icons';
import { SimIconComponent } from '@simOn/ui/sim-icon';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'device-widget-image',
  imports: [CommonModule, SimIconComponent],
  templateUrl: './widget-image.component.html',
  styleUrls: ['./widget-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WidgetImageComponent {
  private readonly _mediaApiService = inject(MediaApiService);
  private _icon: UAnimatedIcon | undefined | null;
  image$: Observable<unknown> | null = null;
  @Input() set file(value: Attachment | undefined | null) {
    if (value?.blobPath) {
      if (value.blobPath?.includes('base64')) {
        this.image$ = of(value.blobPath);
      } else {
        this.image$ = this._mediaApiService.generateBlobUrlForImageDownload({
          url: value.blobPath,
          availableSizes: value.availableSizes,
          size: 'Medium'
        });
      }
    } else {
      this.image$ = null;
    }
  }

  @Input() set icon(value: UAnimatedIcon | undefined | null) {
    this._icon = value;
  }
  get icon(): UAnimatedIcon | undefined {
    return this._icon || 'device_unknown';
  }

  get iconUrl(): string {
    return this._icon ? animatedIconUrl(this._icon) : '';
  }
}
